/**
 * @typedef {import("@prismicio/client").Content.ArticleAuthorSlice} ArticleAuthorSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ArticleAuthorSlice>} ArticleAuthorProps
 * @param {ArticleAuthorProps}
 */
const ArticleAuthor = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}>
      <div className="mx-4 md:mx-10 lg:mx-0 border-t-2 border-dark-grey pt-10 lg:pt-[60px] article-author">
        <p> Rédigé par :
          <span className="author"> {slice.primary.name} </span>
          <span className="point"> • </span>
          <span className="author"> {slice.primary.post} </span>
        </p>
      </div>
    </section>
  );
};

export default ArticleAuthor;
